export interface Permissions {
	pandaDocsAccessRoles: number[];
	checklistAccessRoles: number[];
	underwritingAccessRoles: number[];
	loanCalculatorAccessRoles: number[];
	transunionAccessRoles: number[];
	inveriteAccessRoles: number[];
	loanInterviewAccessRoles: number[];
	exceptionAccessRoles: number[];
	oldloanCalculatorAccessRoles: number[];
	checklistUser: number[];
}

export interface PermissionsState {
	permissions: Permissions | null;
	loading: boolean;
	error: any;
}

export const initialPermissionsState: PermissionsState = {
	permissions: null,
	loading: false,
	error: null,
};
